module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tabbar', {
    staticClass: "flex-tabbar"
  }, [_c('tabbar-item', {
    attrs: {
      "selected": _vm.selectBar === 'eye',
      "link": "/shop/index"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-yanjing red",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "red",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("护眼水")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "selected": _vm.selectBar === 'news',
      "link": "/news/index"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-faxian red",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "red",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("发现")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "selected": _vm.selectBar === 'cart'
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToCart($event)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-icon red",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "red",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("购物车")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "selected": _vm.selectBar === 'uc',
      "link": "/uc/index"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-renwu red",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "red",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("我的")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d5f4caa"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FootNav.vue
// module id = 699
// module chunks = 0